module.exports = __webpack_public_path__ + "assets/img/TrendingNow_cover.6e8310ba-ps.jpg";